"use client";

import { Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ContactInfo() {
  return <section className="bg-background py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-foreground text-center mb-12">
          Contact Information
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="flex items-start gap-4 p-6 rounded-lg bg-secondary-light border border-border shadow-soft">
            <MapPin className="size-6 text-primary shrink-0 mt-1" />
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Address
              </h3>
              <p className="text-base text-muted-foreground leading-relaxed">5F, No. 6, Gaotie E. 2nd Rd.
Zhubei, Hsinchu County
Taiwan 302041<br /><br /></p>
            </div>
          </div>

          <div className="flex items-start gap-4 p-6 rounded-lg bg-secondary-light border border-border shadow-soft">
            <Mail className="size-6 text-primary shrink-0 mt-1" />
            <div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                Email
              </h3>
              <Link to="mailto:info@alphavision-comm.com" className="text-base text-primary-dark transition-colors duration-[var(--duration-medium)]">
                info@alphavision-comm.com
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}